// Reducer for rediscover actions

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaulSOVState = {
  selectedCategory: null,
  selectedMetricDate: null,
  byCategory: {}
}

export const sovNetworksDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_SOV_NETWORKS,
  actionFailure: ActionTypes.REQUEST_SOV_NETWORKS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SOV_NETWORKS,
  actionInvalidate: ActionTypes.INVALIDATE_SOV_NETWORKS
})

export const sovContentRankDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_SOV_CONTENT_RANK,
  actionFailure: ActionTypes.REQUEST_SOV_CONTENT_RANK_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SOV_CONTENT_RANK,
  actionInvalidate: ActionTypes.INVALIDATE_SOV_CONTENT_RANK
})

export const sovContentRankByScoreDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE,
  actionFailure: ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SOV_CONTENT_RANK_SCORE,
  actionInvalidate: ActionTypes.INVALIDATE_SOV_CONTENT_RANK_SCORE
})

export const sovByCategory = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_SOV_NETWORKS:
    case ActionTypes.RECEIVE_SOV_NETWORKS:
    case ActionTypes.REQUEST_SOV_NETWORKS_FAILURE:
    case ActionTypes.INVALIDATE_SOV_NETWORKS:
      return {
        ...state,
        networks: sovNetworksDetails(state.details, action)
      }
    case ActionTypes.REQUEST_SOV_CONTENT_RANK:
    case ActionTypes.RECEIVE_SOV_CONTENT_RANK:
    case ActionTypes.REQUEST_SOV_CONTENT_RANK_FAILURE:
    case ActionTypes.INVALIDATE_SOV_CONTENT_RANK:
      if (action.date) {
        return {
          ...state,
          [action.date]: sovContentRankDetails(state.details, action)
        }
      } else {
        console.warn('SOV action fired without a date:', action)
        return state
      }
    case ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE:
    case ActionTypes.RECEIVE_SOV_CONTENT_RANK_SCORE:
    case ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE_FAILURE:
    case ActionTypes.INVALIDATE_SOV_CONTENT_RANK_SCORE:
    if (action.date) {
      return {
        ...state,
        contentRankByScore: {
          ...state.contentRankByScore,
          [action.date]: sovContentRankByScoreDetails(state.details, action)
        }
      }
    } else {
      console.warn('SOV action fired without a date:', action)
      return state
    }
    default:
      return state
    }
}

export const sov = (state = DefaulSOVState, action) => {
  switch (action.type) {
    case ActionTypes.SOV_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.category
      }
    case ActionTypes.SOV_SELECTED_METRIC_DATE:
      return {
        ...state,
        selectedMetricDate: action.date
      }
    case ActionTypes.REQUEST_SOV_NETWORKS:
    case ActionTypes.RECEIVE_SOV_NETWORKS:
    case ActionTypes.REQUEST_SOV_NETWORKS_FAILURE:
    case ActionTypes.INVALIDATE_SOV_NETWORKS:
    case ActionTypes.REQUEST_SOV_CONTENT_RANK:
    case ActionTypes.RECEIVE_SOV_CONTENT_RANK:
    case ActionTypes.REQUEST_SOV_CONTENT_RANK_FAILURE:
    case ActionTypes.INVALIDATE_SOV_CONTENT_RANK:
    case ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE:
    case ActionTypes.RECEIVE_SOV_CONTENT_RANK_SCORE:
    case ActionTypes.REQUEST_SOV_CONTENT_RANK_SCORE_FAILURE:
    case ActionTypes.INVALIDATE_SOV_CONTENT_RANK_SCORE:
      if (action.category) {
        return {
          ...state,
          byCategory: {
            ...state.byCategory,
            [action.category]: sovByCategory(state.byCategory[action.category], action)
          }
        }
      } else {
        console.warn('SOV action fired without a category:', action)
        return state
      }
    default:
      return state
    }
}